import axios, { AxiosHeaders } from '@node_modules/axios/index.js'

let api = axios.create()

//commenting out in case still needed.
/*const refreshCsrfToken = async () => {
  const csrf = await api.get('/get-csrf-for-session')
    .then(response => response.data.token)
    .catch(() => {
      // eslint-disable-next-line no-undef, no-restricted-globals
      if (confirm('Your session has expired. Please reload the page to continue.')) {
        window.location.reload()
      }
    })
  sessionStorage.setItem('csrf', csrf)
  return csrf
}*/
api.interceptors.request.use((config) => {
  try {
    if (['swansonvitamins', 'localhost'].includes(config?.url) || /^\//.test(config?.url)) {
      config.headers['X-Csrf-Token'] = sessionStorage.getItem('csrf')
    }
    if (config.method.toLowerCase() === 'get') {
      // TODO: fix actual bugs in code passing content to body
      config.data = null
    }
  } catch (error) {
    console.error('axios:interceptors', error)
  }
  return config
})
api.interceptors.response.use((response) => response, async (error) => {
  // CSRF token is invalid, refresh
  if (error?.response?.status === 403) {
    //error.config.headers['X-Csrf-Token'] = await refreshCsrfToken()
    setTimeout(() => {
      // Retry request bypassing interceptors (to avoid infinite loop)
      return axios.request(error.config)
    },60000)
  }
  console.error('axios:interceptors', error)
  return Promise.reject(error)
})
export { AxiosHeaders }

export default api